import apiClient from '../axios';

export interface AdminNoticeItem {
  id: number;
  title: string;
  content: string;
  isActive: boolean;
  regDateTime: string;
  modDateTime: string;
}

export interface CreateNoticeRequest {
  title: string;
  content: string;
  isActive?: boolean;
}

export interface UpdateNoticeRequest {
  title?: string;
  content?: string;
  isActive?: boolean;
}

const ADMIN_NOTICE_URL = () => '/api/admin/notices';

export const noticeApi = {
  /** 공지사항 목록 (어드민) */
  getAll: () => {
    return apiClient.get<AdminNoticeItem[]>(ADMIN_NOTICE_URL());
  },

  /** 공지사항 등록 */
  create: (params: CreateNoticeRequest) => {
    return apiClient.post(ADMIN_NOTICE_URL(), params);
  },

  /** 공지사항 수정 */
  update: (id: number, params: UpdateNoticeRequest) => {
    return apiClient.put(`${ADMIN_NOTICE_URL()}/${id}`, params);
  },

  /** 공지사항 삭제 */
  delete: (id: number) => {
    return apiClient.delete(`${ADMIN_NOTICE_URL()}/${id}`);
  },
};
